// Style constants for the Control Plane section.
//
// Split out of `ui.tsx` for the same reason `navConfig.ts` was split out of
// `Layout.tsx`: a module that exports both components and plain values breaks
// react-refresh, so the values live on their own.

import type { CSSProperties } from "react";

export const card: CSSProperties = {
  background: "var(--bg-card)",
  border: "1px solid var(--border)",
  borderRadius: 4,
};

export const sectionLabel: CSSProperties = {
  fontSize: 10,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.6,
  color: "var(--fg-dim)",
};

export const thStyle: CSSProperties = {
  ...sectionLabel,
  textAlign: "left",
  padding: "0 12px 6px 0",
  whiteSpace: "nowrap",
};

export const tdStyle: CSSProperties = {
  padding: "9px 12px 9px 0",
  borderTop: "1px solid var(--border-faint, #20262e)",
  verticalAlign: "middle",
};

export type StatusTone = "ok" | "warn" | "danger" | "info" | "muted";

export const TONE_COLOR: Record<StatusTone, string> = {
  ok: "var(--ok)",
  warn: "var(--warn)",
  danger: "var(--danger)",
  info: "var(--link)",
  muted: "var(--fg-dim)",
};
